var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "cake"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_cake",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "var(--fill-0, #D9D9D9)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_cake)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cake_2",
    d: "M4.3655 21.5C4.1205 21.5 3.915 21.4138 3.749 21.2413C3.583 21.0689 3.5 20.8603 3.5 20.6152V15.7308C3.5 15.2321 3.67658 14.8061 4.02975 14.4528C4.38308 14.0996 4.80908 13.923 5.30775 13.923H5.5V9.84625C5.5 9.34742 5.67658 8.92142 6.02975 8.56825C6.38308 8.21508 6.80908 8.0385 7.30775 8.0385H11.25V6.56925C10.9565 6.37558 10.7164 6.14833 10.5298 5.8875C10.3433 5.62667 10.25 5.31542 10.25 4.95375C10.25 4.72942 10.2936 4.5125 10.3808 4.303C10.4679 4.09333 10.5987 3.90133 10.773 3.727L12 2.5L13.227 3.727C13.4013 3.90133 13.5321 4.09333 13.6193 4.303C13.7064 4.5125 13.75 4.72942 13.75 4.95375C13.75 5.31542 13.6567 5.62667 13.4703 5.8875C13.2836 6.14833 13.0435 6.37558 12.75 6.56925V8.0385H16.6923C17.1909 8.0385 17.6169 8.21508 17.9703 8.56825C18.3234 8.92142 18.5 9.34742 18.5 9.84625V13.923H18.6923C19.1909 13.923 19.6169 14.0996 19.9703 14.4528C20.3234 14.8061 20.5 15.2321 20.5 15.7308V20.6152C20.5 20.8603 20.4138 21.0689 20.2413 21.2413C20.0689 21.4138 19.8603 21.5 19.6152 21.5H4.3655ZM7 13.923H17V9.84625C17 9.75642 16.9712 9.68267 16.9135 9.625C16.8558 9.56733 16.7821 9.5385 16.6923 9.5385H7.30775C7.21792 9.5385 7.14417 9.56733 7.0865 9.625C7.02883 9.68267 7 9.75642 7 9.84625V13.923ZM5 20H19V15.7308C19 15.6409 18.9712 15.5672 18.9135 15.5095C18.8558 15.4518 18.7821 15.423 18.6923 15.423H5.30775C5.21792 15.423 5.14417 15.4518 5.0865 15.5095C5.02883 15.5672 5 15.6409 5 15.7308V20Z",
    fill: "url(#paint0_linear_cake)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_cake",
    x1: 3.39671,
    y1: 3.32753,
    x2: 23.8585,
    y2: 9.52203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.7fed878b87ed2d469c97f4de1fc0fb15.svg";
export { ForwardRef as ReactComponent };